import { css } from 'lit';
import { hostReset } from '../styles/mixins.js';
import * as t from '../styles/tokens.js';

// ── Panel styles ──────────────────────────────────────────────────────────────
export const panelStyles = [
  hostReset,
  css`
    :host {
      display: block;
      overflow: auto;
      min-width: 0;
      min-height: 0;

      /* Custom scrollbar */
      scrollbar-width: thin;
      scrollbar-color: ${t.border} transparent;
    }
    :host::-webkit-scrollbar       { width: 5px; height: 5px; }
    :host::-webkit-scrollbar-thumb {
      background:    ${t.border};
      border-radius: ${t.radiusFull};
    }
  `,
];

// ── Splitter styles ───────────────────────────────────────────────────────────
export const splitterStyles = [
  hostReset,
  css`
    :host {
      display:   flex;
      overflow:  hidden;
      width:     100%;
      height:    100%;
    }

    :host([layout='vertical']) {
      flex-direction: column;
    }

    /* Slot is transparent — panels/gutters become direct flex children */
    slot {
      display: contents;
    }

    /* ── Slotted panels ────────────────────────────────────────────────── */
    ::slotted(uwc-splitter-panel) {
      flex-shrink: 0;
      flex-grow:   0;
      overflow:    hidden;
      min-width:   0;
      min-height:  0;
    }

    /* ── Gutters (injected as light-DOM divs, distributed via default slot) */
    ::slotted(.uwc-splitter__gutter) {
      flex-shrink:      0;
      flex-grow:        0;
      position:         relative;
      display:          flex;
      align-items:      center;
      justify-content:  center;
      z-index:          1;
      outline:          none;
      /* background / cursor set via inline styles (dynamic) */
    }

    ::slotted(.uwc-splitter__gutter:focus-visible) {
      background-color: var(--uwc-splitter-gutter-focus-bg, ${t.selectedBg}) !important;
    }
  `,
];
